<p style="margin-top: 16px">{{'aumico_admin_ar_template_define_pdf_template' | i18next }}</p>

<div class="container">
    <div>
        <div class="file-upload">
            <aumico-file-upload
                [tint]="true"
                [accept]="'.docx'"
                [extensionErrorKey]="'aumico_admin_ar_template_pdf_error_notification_description_file_type_invalid'"
                (fileChange)="onFileUploadedChanged($event)"
            >
            </aumico-file-upload>
        </div>

        <div *ngIf="savedPdfTemplateId"></div>
    </div>
    <div class="reset-section">
        <div *ngIf="savedPdfTemplateName">
            <div>{{'aumico_admin_ar_template_uploaded_pdf_template_name'|i18next}}:</div>
            <div class="pdf-template-name">{{savedPdfTemplateName}}</div>

            <p style="margin-top: 16px">{{'aumico_admin_ar_template_download_pdf_template'|i18next}}:</p>

            <span class="pdf-template-name" (click)="downloadPdfTemplate()">
                <mat-icon svgIcon="aumico-pattern-xls-file-icon-purple"></mat-icon>
                <span class="file-name"> {{savedPdfTemplateName}} </span>
            </span>
        </div>
        <div *ngIf="!savedPdfTemplateName">
            <div>{{'aumico_admin_ar_template_no_custom_pdf_template_uploaded'|i18next}}</div>
        </div>
        <div class="add-margin">
            <ham-button color="primary" (click)="resetTemplateToDefault()">
                {{'aumico_admin_ar_template_reset_pdf_template_to_default_button'|i18next}}
            </ham-button>
        </div>
    </div>
</div>
